// Visual Testing Lab — Module Registry
// Defines which application modules can be opened in the visual lab iframe,
// how highlight zones are filtered, and which drill-down steps make up the
// "testing tour" for that module.

export const VISUAL_MODULES = [
  {
    id: 'dashboard-2',
    name: 'Daily Dashboard',
    route: '/dashboard-2',
    description:
      'The primary daily cockpit: Command Band metrics, Day Planner timeline, and Unplanned Backlog panes.',
    // Regex-style prefix filters applied to data-testid values. Keep the overlay
    // focused on meaningful interaction surfaces (not every inline badge).
    testidPrefixes: [
      'dd2-',
      'today-command',
      'focus-strip',
      'orka-task-header',
      'task-row-',
    ],
    // Drill-down tour — ordered steps that highlight a specific zone.
    steps: [
      {
        id: 'command-band',
        title: 'Today Command Band',
        testid: 'today-command-band',
        fallbackTestid: 'dd2-command-left-actions',
        hint:
          'The top strip shows daily metrics (tasks due, done, overdue, effort) and the primary date navigator. Click a metric to filter the panes below.',
        testCaseRef: null,
      },
      {
        id: 'day-nav',
        title: 'Date Navigation',
        testid: 'dd2-today',
        hint:
          'Use arrows to navigate day-by-day. The "Today" button snaps back to the current date and triggers an auto-scroll to the "now" line on the timeline.',
      },
      {
        id: 'sync-day',
        title: 'Sync Day',
        testid: 'dd2-sync-day',
        hint:
          'Pulls the latest calendar events, tasks and focus signals for the selected day. Expect a toast confirmation on success.',
      },
      {
        id: 'new-task',
        title: 'Create New Task',
        testid: 'dd2-new-task',
        hint:
          'Opens the task modal pre-scoped to the selected day. Title, priority, effort and work area can be set inline.',
      },
      {
        id: 'panes',
        title: 'Dual-Pane Layout',
        testid: 'dd2-panes',
        hint:
          'Left pane = Day Planner (timeline). Right pane = Unplanned Backlog. The vertical and horizontal resizers let you tune the split.',
      },
      {
        id: 'view-toggle',
        title: 'View Toggle',
        testid: 'dd2-view-toggle',
        hint:
          'Switch between Responsible / Supporting / Both perspectives. Affects which tasks appear in both panes.',
      },
      {
        id: 'observer-toggle',
        title: 'Observer Mode',
        testid: 'dd2-observer-only',
        hint:
          'When enabled, you only see tasks where you are an observer/supporter — useful for standups and team reviews.',
      },
    ],
  },
];

export function getModuleById(id) {
  return VISUAL_MODULES.find((m) => m.id === id) || null;
}
